import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { FileText, Award, BookOpen } from 'lucide-react';

const ResearchSection = () => {
  const sectionRef = useScrollReveal();

  const certifications = [
    { name: 'Critical Care Life Support (CCLS)', issuer: 'Certified' },
    { name: 'Basic Cardiac Life Support (BCLS)', issuer: 'Certified' }
  ];

  return (
    <section id="research" className="py-20 px-4 bg-white" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          Research & Certifications
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Research/Thesis */}
          <Card className="card-hover scroll-reveal-scale" style={{ borderColor: '#e8f5e9', animationDelay: '0.2s' }}>
            <CardHeader>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#e8f5e9' }}>
                  <FileText style={{ color: 'var(--medical-primary)' }} size={24} />
                </div>
                <CardTitle className="text-2xl text-slate-900">MD Thesis</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <h3 className="text-lg font-semibold text-slate-800 mb-3">
                Study on Liver Cirrhosis
              </h3>
              <p className="text-slate-700 mb-4">
                Comprehensive research utilizing APRI (AST to Platelet Ratio Index) and MELD (Model for End-Stage Liver Disease) scoring systems for prognostic assessment in liver cirrhosis patients.
              </p>
              <div className="flex flex-wrap gap-2">
                <Badge variant="secondary" style={{ backgroundColor: '#e8f5e9', color: 'var(--medical-primary)' }}>
                  APRI Score
                </Badge>
                <Badge variant="secondary" style={{ backgroundColor: '#e8f5e9', color: 'var(--medical-primary)' }}>
                  MELD Score
                </Badge>
                <Badge variant="secondary" style={{ backgroundColor: '#e8f5e9', color: 'var(--medical-primary)' }}>
                  Hepatology
                </Badge>
              </div>
            </CardContent>
          </Card>

          {/* Certifications */}
          <Card className="card-hover scroll-reveal-scale" style={{ borderColor: '#e8f5e9', animationDelay: '0.35s' }}>
            <CardHeader>
              <div className="flex items-center gap-3 mb-2">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#e8f5e9' }}>
                  <Award style={{ color: 'var(--medical-primary)' }} size={24} />
                </div>
                <CardTitle className="text-2xl text-slate-900">Certifications</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {certifications.map((cert) => (
                  <div key={cert.name} className="flex items-start gap-3 p-4 bg-slate-50 rounded-lg transition-all duration-300 hover:bg-slate-100">
                    <BookOpen style={{ color: 'var(--medical-primary)' }} className="flex-shrink-0 mt-1" size={20} />
                    <div>
                      <h3 className="font-semibold text-slate-900 mb-1">{cert.name}</h3>
                      <p className="text-sm text-slate-600">{cert.issuer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ResearchSection;
